import { render, staticRenderFns } from "./ShimmerEffectMultiple.vue?vue&type=template&id=7b9b003e&scoped=true"
import script from "./ShimmerEffectMultiple.vue?vue&type=script&lang=js"
export * from "./ShimmerEffectMultiple.vue?vue&type=script&lang=js"
import style0 from "./ShimmerEffectMultiple.vue?vue&type=style&index=0&id=7b9b003e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b003e",
  null
  
)

export default component.exports